import jBox from 'jbox';
import 'jbox/dist/jBox.all.css';

jQuery(document).ready(function () {

    if( jQuery('.page-template-tickets-single-session').length > 0 ){

        // Hide all tabs except the first one by default
        jQuery('.tickets__holder').hide();
        jQuery('.tickets__holder:first').show();
        jQuery('.tabs__button:first').addClass('active');

        // Handle tab click
        jQuery('.tabs__button').click(function () {
            var tab_id = jQuery(this).data('tab');

            // Remove active class from all buttons and add to the clicked one
            jQuery('.tabs__button').removeClass('active');
            jQuery(this).addClass('active');

            // Hide all tab content and show the selected tab
            jQuery('.tickets__holder').hide();
            jQuery(tab_id).show();
        });


        console.log(jQuery('#tooltip_left'))


        new jBox('Tooltip', {
            attach: '.tooltip',
            closeOnMouseleave: true,
        });

        jQuery('#tooltip_left').jBox('Tooltip', {
            pointer: 'top:15', // The pointer is moved to the right with a 15 pixel offset
            closeOnMouseleave: true,
        });

    }

});